import script from "./ScrollReveal.vue?vue&type=script&setup=true&lang=js"
export * from "./ScrollReveal.vue?vue&type=script&setup=true&lang=js"

import "./ScrollReveal.vue?vue&type=style&index=0&id=1465b874&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1465b874"]])

export default __exports__